import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import fetchAPI from 'utils/http/fetchAPI';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
var sendInvites = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(addedUsers, projectInfo) {
    var silent,
      id,
      name,
      role,
      requests,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            silent = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            id = projectInfo.id, name = projectInfo.name, role = projectInfo.role;
            requests = addedUsers.map(/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(user) {
                var _response, _messageToDisplay;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fetchAPI("/v2/access/".concat(id), {
                          method: 'PUT',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                            // TODO nothing in the api v2 should use a reference to project,
                            // so we'll need a ticket to fix this in this api endpoint
                            projectUuid: id,
                            role: role,
                            userEmail: user
                          })
                        });
                      case 3:
                        _response = _context.sent;
                        if (!silent) {
                          if (role === 'explorer') {
                            pushNotificationMessage('success', "User ".concat(user, " has been successfully invited to view ").concat(name, "."));
                          } else if (role === 'owner') {
                            pushNotificationMessage('success', "Project ".concat(name, " has been transferred to ").concat(user, "."));
                          }
                        }
                        return _context.abrupt("return", _response);
                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](0);
                        if (!silent) {
                          _messageToDisplay = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.userMessage) === 'NotificationFailure' ? endUserMessages.SHARE_SUCESS_NOTIFICATION_FAILURE : endUserMessages.SHARE_FAILURE;
                          handleError(_context.t0, _messageToDisplay);
                        }
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 8]]);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }());
            return _context2.abrupt("return", Promise.all(requests));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function sendInvites(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default sendInvites;